import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonApiService } from '../../../common-api.service';
import { SpeakerService } from '../../../speaker.service';
import { SnackbarService } from '../../../snackbar.service';
import { CommonDropdownService } from '../../../common-dropdown.service';
import { PaginatedDropdown } from '../../../util/paginated-dropdown';

@Component({
  selector: 'app-all-doctors',
  templateUrl: './all-doctors.component.html',
  styleUrls: ['./all-doctors.component.css']
})
export class AllDoctorsComponent implements OnInit, OnDestroy {

  public allDoctors: any[] = [];
  public city: PaginatedDropdown;

  displayColumns = [
    'name',
    'registration_no',
    'address_1',
    'address_2',
    'city_name',
    'state_name',
    'mobile',
    'email',
    'gst_no',
  ];
  displayHeaders = [
    'Doctor name',
    'Registration Date',
    'Address Line 1',
    'Address Line 2',
    'City',
    'State',
    'Mobile No.',
    'Email',
    'Gst No.',
    'Manger Name',
  ];

  constructor(
    public speaker: SpeakerService,
    private api: CommonApiService,
    private snackbar: SnackbarService,
    private dropdownService: CommonDropdownService,
  ) {
    this.city = new PaginatedDropdown(this.api, this.dropdownService, 'area');
  }

  ngOnInit(): void {
    this.speaker.listData = this.allDoctors;
    this.city.selectedId = 0;
    this.city.init();
  }

  ngOnDestroy(): void {
    this.city.destroy();
  }

  getReportDetails(data: any) {
    this.speaker.isLoading = true;
    this.api.callRoute('doctor', '/alldoctors', data).subscribe({
      next: (res) => {
        this.speaker.isLoading = false;
        this.allDoctors = res;
        this.speaker.listData = this.allDoctors;
        if (this.allDoctors.length == 0) {
          this.snackbar.info('No records found');
          return;
        }
      },
      error: () => { this.speaker.isLoading = false; }
    });
  }

  generateReport() {
    const data = {
      city_id: this.city.selectedId,
    };
    this.speaker.listData = [];
    this.getReportDetails(data);
    this.speaker.model = 'doctor';
    this.speaker.displayColumns = this.displayColumns;
    this.speaker.displayHeaders = this.displayHeaders;
  }
}
